import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/hr/planning/')({
  loader: () => {
    throw redirect({ to: '/hr/planning/$tab', params: { tab: 'dashboard' } })
  },
})
